import { api } from './NetworkUtility';

export const resendInviteNotification = (request, companyNumber, callbackHandler) => {

    const url = `/companies/${companyNumber}/notifications/resendInvite`;

    api.post(url, request)
    .then(response => {
        callbackHandler(response);
    })
    .catch(error => {
        callbackHandler(error.response);
    });
}
